<template>
  <router-link
    :to="{name: 'derby_info', params: {derbyId: derbyId}}"
  ><slot>{{text}}</slot></router-link>
</template>

<script>
export default {
  name: 'DerbyLink',

  props: {
    derbyId: {
      type: Number,
      required: true,
    },

    label: {
      type: String,
      default: 'derby',
    }
  },

  computed: {
    /** @returns {string} */
    text() {
      const label = this.label;
      const idStr = this.derbyId.toString();

      if(label.length > 0) {
        return label + ' ' + idStr;
      }

      return idStr;
    },
  },
}
</script>
